// @ts-nocheck
export const ConsentActions = {
  implied: 'implied',
  user_click: 'user_click',
  import: 'import',
};

export const ConsentStates = {
  accepted: 'accepted',
  declined: 'declined',
  implied: 'implied',
  viewed: 'viewed',
};

const CONSENT_SUBCATEGORIES = {
  custom: [],
  communication: ['email', 'phone'],
  disclosure: ['privacy_policy', 'terms_of_service'],
  privacy_setting: [
    'marketing',
    'analytics',
    'strictly_necessary',
    'functional',
    'unclassified',
  ],
};

export const ConsentCategories = Object.keys(CONSENT_SUBCATEGORIES);

// export const ConsentSubcategories = (category) => CONSENT_SUBCATEGORIES[category];

export const ConsolidatedConsentCategories = {};

for (let i = 0; i < ConsentCategories.length; i += 1) {
  const categoryKey = ConsentCategories[i];
  const subcategories = CONSENT_SUBCATEGORIES[categoryKey];
  ConsolidatedConsentCategories[categoryKey] = {};
  for (let z = 0; z < subcategories.length; z += 1) {
    const subCategory = subcategories[z];
    ConsolidatedConsentCategories[categoryKey][subCategory] = subCategory;
  }
}
